<template>
  <div class="container">
    <h3 class="title">{{ $t('currency.customCads') }}</h3>
    <div class="fabric-cads-content">
      <div class="filters f--c">
        <el-input v-model.trim="filters.collectionName" clearable size="mini" placeholder="search" style="width: 300px;" @change="pageCurrentChange(1)">
          <el-button slot="append" icon="el-icon-search" @click="pageCurrentChange(1)"></el-button>
        </el-input>
      </div>
      <div class="fabric-cads-box">
        <div class="fabric-cads-list f">
          <div v-for="item in list" :key="item.id" class="fabric-item" @click="jump(item.id)">
            <!-- <div class="img pointer" @click="jump(item.fabricId)">
              <oss-img :src="item.coverUrl" :width="600" />
            </div> -->
            <div class="box-item f-c-c">
              <div class="img-box">
                <oss-img :src="item.coverUrl" :width="1200" :height="848" :alt="item.collectionName" />
              </div>
            </div>
            <div class="name ellipsis pointer" :title="item.enName">{{item.collectionName}}</div>
          </div>
        </div>
        <div v-if="list.length === 0" style="text-align:center;">No Data</div>
      </div>
      <div style="text-align:right;margin-top:10px" class="bg-white">
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[20, 50, 100, 200]"
          :total="total"
          :current-page.sync="filters.pageNumber"
          :page-size="filters.pageSize"
          @current-change="pageCurrentChange"
          @size-change="pageSizeChange"/>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api'
export default {
  data() {
    return {
      list: [],
      total: 0,
      filters: {
        pageNumber: 1,
        pageSize: 20,
        collectionName: ''
      }
    }
  },
  created() {
    this.getpushCollection()
  },
  methods: {
    getpushCollection() {
      API.getpushCollection(this.filters).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.list = res.data.list || []
        this.total = res.data.total
      })
    },
    jump(id) {
      this.$router.push(`/order/custom-cads/detail?id=${id}`)
    },
    pageSizeChange(pageSize) {
      this.filters.pageSize = pageSize
      this.getpushCollection()
    },
    pageCurrentChange(page) {
      this.filters.pageNumber = page
      this.getpushCollection()
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  max-width: 1400px;
  min-width: 1000px;
  margin: 0 auto;
  padding: 15px;
  padding-bottom: 4px;
  .title {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    margin-bottom: 15px;
  }
}
.fabric-cads-content {
  background-color: #fff;
  padding: 16px 10px 10px 16px;
  .filters {
    margin-bottom: 10px;
    flex-wrap: wrap;
    >div {
      margin-right: 10px;
      margin-bottom: 6px;
    }
    /deep/ .el-input__inner {
      border-radius: unset;
    }
  }

  .fabric-cads-box {
    height: calc(100vh - 220px);
    // padding-right: 10px;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;
    }
  }
  .fabric-cads-list {
    flex-wrap: wrap;
    .fabric-item {
      width: calc((100% - 40px) / 4);
      height: 100%;
      margin-right: 10px;
      padding-bottom: 16px;

      .box-item {
        cursor: pointer;
        position: relative;
        height: 0;
        padding-bottom: 56%;
        .img-box {
          display: flex;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: #f5f5f5;
        }
        img {
          width: 100%;
          object-fit: contain
        }
      }

      // .img {
      //   width: 100%;
      //   // aspect-ratio: 1 / 1;
      //   img {
      //     width: 100%;
      //     height: 100%;
      //     object-fit: cover;
      //   }
      // }
      &:nth-child(4n) {
        margin-right: 0;
      }
      .name {
        font-size: 16px;
        margin: 6px 0;
      }
    }
  }
}
</style>
